var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.04 14.4811C17.62 14.8911 17.38 15.4811 17.44 16.1111C17.53 17.1911 18.52 17.9811 19.6 17.9811H21.5V19.1711C21.5 21.2411 19.81 22.9312 17.74 22.9312H6.26C4.19 22.9312 2.5 21.2411 2.5 19.1711V12.4412C2.5 10.3712 4.19 8.68115 6.26 8.68115H17.74C19.81 8.68115 21.5 10.3712 21.5 12.4412V13.8812H19.48C18.92 13.8812 18.41 14.1011 18.04 14.4811Z",
    fill: "#5B6B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 4.88115V8.68114H6.26C4.19 8.68114 2.5 10.3712 2.5 12.4412V8.77117C2.5 7.58117 3.23 6.52112 4.34 6.10112L12.28 3.10112C13.52 2.64112 14.85 3.55115 14.85 4.88115Z",
    fill: "#5B6B79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.56 14.9011V16.9611C22.56 17.5111 22.12 17.9611 21.56 17.9811H19.6C18.52 17.9811 17.53 17.1911 17.44 16.1111C17.38 15.4811 17.62 14.8911 18.04 14.4811C18.41 14.1011 18.92 13.8811 19.48 13.8811H21.56C22.12 13.9011 22.56 14.3511 22.56 14.9011Z",
    fill: "#5B6B79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.6812H7C6.59 13.6812 6.25 13.3412 6.25 12.9312C6.25 12.5212 6.59 12.1812 7 12.1812H14C14.41 12.1812 14.75 12.5212 14.75 12.9312C14.75 13.3412 14.41 13.6812 14 13.6812Z",
    fill: "#5B6B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWallet);
export default __webpack_public_path__ + "static/media/empty-wallet.d0409ad8f64cb5c03a6210243c01d5b3.svg";
export { ForwardRef as ReactComponent };